import * as React from 'react';
const SvgSitemap = (props) => (
  <svg viewBox="0 0 124 114" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M95.744 2H29.622v27.426h66.122V2ZM52.85 54.978H3.666v18.334h49.182V54.978ZM121.7 54.978H72.518v18.334H121.7V54.978ZM62.684 29.426v10.937M28.256 49.157v-8.799h68.856v14.615M10.833 89.385v-5.273h34.84v9.397M28.692 73.657v10.455M19.671 94.337H2V112h17.671V94.337ZM54.511 94.337H36.84V112H54.51V94.337ZM113.162 89.385v-5.273h-34.84v9.397M96.182 73.657v10.455M87.16 94.337H69.49V112h17.67V94.337ZM122 94.337h-17.672V112H122V94.337Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgSitemap;
